export const CATEGORY = "Categories";
export const getFiltersBaseOnFlotiqResponse = (stores, filtersTranslations) => {
    const getCategoryConfig = (key) => {
        const categoryConfig = filtersTranslations.find(({ filterKey }) => filterKey === key);
        return {
            translatedName: categoryConfig?.translatedFilterKey || key,
            imageReference: categoryConfig?.image,
        };
    };
    return stores.reduce((acc, store) => {
        store[CATEGORY]?.forEach((item) => {
            const categoryConfig = getCategoryConfig(item.key);
            if (!acc.some((filter) => filter.categoryKey === item.key)) {
                acc.push({
                    label: categoryConfig.translatedName,
                    categoryKey: item.key,
                    iconUrl: categoryConfig.imageReference,
                });
            }
        });
        return acc;
    }, []);
};
//# sourceMappingURL=getFiltersBaseOnFlotiqResponse.js.map